import React from "react";

const LeadSubHeader = ({
  filterOptions,
  setActiveFilter,
  setActiveTabLabel,
  activeFilter,
  activeTabLabel,
  tabCounts,
}) => {
  return (
    <>
      <div className="flex gap-2 p-1 bg-slate-100/60 rounded-full">
        {filterOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => {
              sessionStorage.removeItem("leads_scroll");
              setActiveFilter(option.value);
              setActiveTabLabel(option.label);
            }}
            className={`flex-1 py-2 px-1 sm:px-4 rounded-full font-medium text-sm transition-all duration-200 ${
              activeFilter === option.value
                ? "bg-gradient-to-r from-[#00a8b4fa] to-[#00c8d391] text-white shadow-sm"
                : "text-slate-600 hover:text-slate-900"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="mt-2 py-0 text-lg font-semibold">
        Total {activeTabLabel} Leads ({tabCounts[activeFilter] ?? "…"})
      </div>
    </>
  );
};

export default LeadSubHeader;
